export const ADD_NOTIFICATION_EVENT = 'ADD_NOTIFICATION';
